import { QuestKeyType } from './quest.model';

export class QuestRequest {
  constructor(
    public key?: string,
    public keyType?: QuestKeyType
  ) {}
}
